var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"grid",class:{
        right: _vm.colidx == _vm.layout.cols,
        bottom: _vm.rowidx == _vm.layout.rows,
    },style:(_vm.style)})
}
var staticRenderFns = []

export { render, staticRenderFns }